import React, { Fragment, PureComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { formatCurrency } from 'src/helpers/formatters'
import { Button, If } from 'src/Components'
import AdditionalInfo from 'src/Components/AdditionalInfo'
import { IconBotHeadCircle } from 'src/Components/Icon'
import Input from 'src/Components/Input'

import styles from './EstimateAdjuster.module.scss'

class EstimateAdjuster extends PureComponent {
  state = {
    open: false
  }

  toggleOpen = (open = !this.state.open) => {
    this.setState({ open })
  }

  renderPrompt () {
    const { loading, estimatedPmi, onConfirm } = this.props
    const confirmLoading = loading && loading === 'confirm'

    return (
      <div className={styles.container}>
        <span className={styles.question}>
          <IconBotHeadCircle />{' '}
          <FormattedMessage
            id='Homeowner.mortgageInsurance.estimate'
            defaultMessage='{estimate} is our estimate. Is this correct?'
            values={{ estimate: formatCurrency(estimatedPmi) }}
          />
        </span>
        <Button.Group className={styles.buttonGroup}>
          <Button loading={confirmLoading} compact onClick={onConfirm}>
            <FormattedMessage
              id='Homeowner.mortgageInsurance.estimateConfirmButton'
              defaultMessage='Yes'
            />
          </Button>
          <Button
            disabled={confirmLoading}
            compact
            onClick={() => this.toggleOpen()}
          >
            <FormattedMessage
              id='Homeowner.mortageInsurance.estimateDenyButton'
              defaultMessage='No'
            />
          </Button>
        </Button.Group>
      </div>
    )
  }

  renderAdditionalInfo () {
    const { loading, onChange, onSubmit, onNone, pmi } = this.props
    const { open } = this.state
    const manualLoading = loading && loading === 'manual'

    return (
      <AdditionalInfo visible={open} cardWidth>
        <p>
          <FormattedMessage
            id='Homeowner.mortgageInsurance.howMuchPMIHeadline'
            defaultMessage='How much is your monthly private mortgage insurance (PMI)?'
          />
        </p>
        <form onSubmit={onSubmit}>
          <Input
            className={styles.input}
            type='number'
            placeholder='0.00'
            min='0.00'
            step='0.01'
            name='amount'
            value={pmi}
            onChange={onChange}
            required
          />
          <Button.Group className={styles.actions}>
            <If condition={manualLoading}>
              <Button primary compact loading />
            </If>
            <If condition={!manualLoading}>
              <Button primary compact type='submit'>
                <FormattedMessage
                  id='Homeowner.mortgageInsurance.saveButton'
                  defaultMessage='Save'
                />
              </Button>
              <Button compact onClick={onNone}>
                <FormattedMessage
                  id='Homeowner.mortgageInsurance.noPMIButton'
                  defaultMessage="I don't have PMI"
                />
              </Button>
            </If>
          </Button.Group>
        </form>
      </AdditionalInfo>
    )
  }

  render () {
    return (
      <Fragment>
        {this.renderPrompt()}
        {this.renderAdditionalInfo()}
      </Fragment>
    )
  }
}

export default EstimateAdjuster
